import { trackEvent } from "./consultTracking";

/**
 * Centralized event handlers for consult actions
 */

export const handleEhrSelectionSubmit = async (
  data: any,
  session: any,
): Promise<boolean> => {
  try {
    // Simulate API call
    await new Promise((resolve) => setTimeout(resolve, 1000));

    trackEvent(
      "EHR Selection Submitted",
      {
        "Selected EHR":
          data.ehrSystem === "Other" ? data.customEhr : data.ehrSystem,
        "Interested In Early Access": data.interestedInEarlyAccess,
      },
      {
        userEmail: session?.userEmail || data.email,
        clinicName: session?.clinicName || data.clinicName,
      },
    );

    return true;
  } catch (error) {
    console.error("Error submitting EHR selection:", error);
    return false;
  }
};

export const handleGalleryClose = (
  selectedPatientName: string,
  selectedPhotos: string[],
  setGalleryModalVisible: (visible: boolean) => void,
  currentView: string,
  session: any,
) => {
  trackEvent(
    "Photo Gallery Modal Closed",
    {
      "Patient Name": selectedPatientName,
      "Photo Count": selectedPhotos.length,
      "View Mode": currentView,
    },
    session,
  );

  setGalleryModalVisible(false);
};

export const handleGalleryImageView = (
  index: number,
  selectedPatientName: string,
  currentView: string,
  session: any,
) => {
  trackEvent(
    "Photo Gallery Image Viewed",
    {
      "Patient Name": selectedPatientName,
      "Image Index": index,
      "View Mode": currentView,
    },
    session,
  );
};
